module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_8023.1bb6d920.png";